import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboRazaActiva`, method: 'GET', body: null, token: token})
}
